// extracted by mini-css-extract-plugin
module.exports = {"settings":"style_settings__2WJdR","settings_text":"style_settings_text__14YHA","settings_on_off":"style_settings_on_off__1UkLu"};